import _omit from 'lodash/omit';

import {
  ACTION_ADD_CUSTOM_BANNER,
  ACTION_LOAD_CUSTOM_BANNERS__REQUEST,
  ACTION_LOAD_CUSTOM_BANNERS__SUCCESS,
  ACTION_LOAD_CUSTOM_BANNERS__FAIL,

  ACTION_DELETE_CUSTOM_BANNER__SUCCESS,
} from '../actionTypes';


const customBanners = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_CUSTOM_BANNERS__REQUEST:
    case ACTION_LOAD_CUSTOM_BANNERS__FAIL:
      return null;

    case ACTION_LOAD_CUSTOM_BANNERS__SUCCESS:
      return action.payload.customBanners;

    case ACTION_ADD_CUSTOM_BANNER: {
      const { id } = action.payload.customBanner;
      return { ...state, [id]: action.payload.customBanner };
    }

    case ACTION_DELETE_CUSTOM_BANNER__SUCCESS:
      return _omit(state, action.payload.bannerId);

    default:
      return state;
  }
};

export default customBanners;
